export default __webpack_public_path__ + "static/media/Coursera Responsive Website Basics University of London.6ba0adb8.webp";